import { ReactElement, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { enterOutline, person } from "ionicons/icons";
import styled from "styled-components";
import Button from "../../../atoms/Button";
import Gap from "../../../atoms/Gap";
import {
  LOGOECEVE,
  LOGOINSERM,
  LOGOPARISUNI,
  LOGORECHERCHE,
  LOGOSANTE
} from "../../../../constants/images";
import Title from "../../../atoms/Title";
import AnonymousData from "../../../molecules/Home/Consent/DisplayAnonymousData";
import VeriticalCenter from "../../../atoms/VerticalCenter";
import Container from "../../../atoms/Container";
import { useHomeContext } from "../../../../pages/Home/HomeContent";
import { useConfig } from "../../../../contexts/ConfigContext";
import { UserStatus, WelcompeStepEnum } from "../../../../types/welcome";
import { black } from "../../../../theme/theme";
import { ResonanceLayoutProvider, useResonanceLayout } from '../../ResonanceContext/ResonanceLayoutContext';
import EmailLoginFields from "../../../molecules/Home/Login/EmailLoginFields";
import SecretQuestionsForm from "../LoginJourney/SecretQuestionsForm";
import ForgotPwdModal from "../../../../pages/Profile/ForgotPasswordModal";
import { IdentificationMethodEnum } from "../../../../types/profile";
import useToast from "../../../../hooks/useToast";
import { useHistory, useParams } from "react-router";
import AuthContext from "../../../../contexts/AuthContext";
import { login } from "../../../../services/user.service";
import { FormGroup } from "../../../atoms/LoginTextField";
import { useIonRouter, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import ResonanceLayout from "../../ResonanceContext/ResonanceLayout";





const DisplayHasAccount = (): ReactElement | null => {
  const { t } = useTranslation();
  useIonViewWillEnter(() => {
    console.count("DispalyHasAccount entered"); // will count 1, 2, 3 in dev, but once in prod
  });

  const { welcomeData, setCurrentStep, createUser } = useHomeContext();
  const { selectedRole } = useConfig();
  const userStatus = welcomeData.invitations?.to_user?.user_status as string;

  const { study_slug } = useParams<{ study_slug: string }>();
  const { startSession, user, isAuthenticated } = useContext(AuthContext);
  const history = useHistory();
  const present = useToast();
  const studyId = welcomeData.id;
  const roleId = welcomeData?.roles[0].id;
  const ionRouter = useIonRouter();
  const invitation_token = new URLSearchParams(window.location.search).get("invitation");
  const isActive = userStatus === UserStatus.ACTIVE;
  const invitSignOnly = !welcomeData?.roles[0].attributes?.can_sign_up_only_with_invitation || invitation_token;

 
  const { method, identification_questions } = welcomeData?.roles[0].signin_criteria || {};
  const { setResonanceLayout, welcomePage } = useResonanceLayout();


  // useEffect(() => {
  //   // mark this page as “welcome” while it is mounted
  //   if (!isAuthenticated){
  //     setResonanceLayout({ title: "", disableNav:true, welcomePage: true, disableHeader: false, backgroundColor: "white" });
  //   }
    

  //   // ⬇️ this runs *before* the component actually unmounts
  //   return () => {
  //     if (isAuthenticated){
  //       setResonanceLayout({ welcomePage: false, disableHeader: true, disableNav: false, backgroundColor: "white" });
  //     }
      
  //   };
  // }, []);               // ← same dependency list

  useIonViewWillEnter(() => {
    if (!isAuthenticated){
      setResonanceLayout({
        disableHeader: false,
        disableNav: true,
        backgroundColor: "white",
        title: "",
        welcomePage: true,
      });
    }
  });

  useIonViewWillLeave(() => {
    if (isAuthenticated){
        setResonanceLayout({
        disableHeader: true,
        disableNav: false,
        backgroundColor: "white",
        welcomePage: false,
      });
    }
  });

  // if (!welcomePage) return null;

  const handleConnect = async (body: any) => {
    try {
      const { data } = await login(studyId, roleId, { ...body, invitation_token });
      await startSession(data.token);
      // setResonanceLayout({ welcomePage: false, disableHeader: true });
      // setCurrentStep(WelcompeStepEnum.HAS_ACCOUNT);
      console.log("study_slug:", study_slug);
      console.log("studyID: ", studyId)
      console.log("User", user);
      // history.push(`/${study_slug}/home`);
      // ionRouter.push(`/${study_slug}/home`, 'forward', 'replace');
      const slug = study_slug ?? "mentalplus";
      ionRouter.push(`/${slug}/tabs/home`, 'root', 'replace', { unmount: true });


      console.log("Redirecting after history.replace!");
      console.log("url:", window.location.pathname);
    } catch (e) {
      present("Votre identifiant ou mot de passe est incorrect.");
      console.error(e);
    }
  };

  const onAccountClick = (): void => setCurrentStep(WelcompeStepEnum.LOGIN);

  const onNewClick = (): void => {
    console.log("Creating user with role:", welcomeData?.roles[0]);
    createUser(welcomeData?.roles[0]);
  };


  


  







  return (
    <div style={{ marginTop: "20px" }}>
    <Container>
      <VeriticalCenter style={{ justifyContent: "space-around", minHeight: "80vh", maxHeight: "1000px",     // prevents excessive spacing on big screens
    margin: "0 auto" }}>
        <ScreenTitle>{t("home_welcome")}</ScreenTitle>
        <Description>{t("home_description")}</Description>

        <Gap size="2.5%" />
        {/* <Title>{t("home_login_subtitle")}</Title> */}

        {method === IdentificationMethodEnum.EMAIL && (
          <EmailLoginFields onConnect={handleConnect} />
        )}
        {method === IdentificationMethodEnum.NICKNAME_PASSWORD && (
          <EmailLoginFields onConnect={handleConnect} withNickName />
        )}
        {method === IdentificationMethodEnum.SECRET_QUESTIONS && (
          <SecretQuestionsForm
            onConnect={handleConnect}
            secretQuestions={identification_questions}
          />
        )}

         <Gap mt="20px" />
        
        {(invitSignOnly && !isActive) && (
          <>
            
            <Gap size="2.5%" />
            {/* <Title>{t("home_new")}</Title> */}
            <LoginButton onClick={onNewClick} icon={person}>
              {t("home_has_account_false")}
            </LoginButton>
          </>
        )}

        {/* <RegistredButton onClick={onAccountClick} icon={enterOutline}>
          {t("home_has_account_true")}
        </RegistredButton> */}

        <Gap size="5%" />
        {/* <AnonymousData /> */}

        <LogoContainer>
          <Logo src={LOGOECEVE} />
          <Logo src={LOGOINSERM} />
          <Logo src={LOGOPARISUNI} />
          <Logo src={LOGOSANTE} />
          <Logo src={LOGORECHERCHE} />
        </LogoContainer>
      </VeriticalCenter>
    </Container>
    </div>
  );
};

const ScreenTitle = styled.h1`
  text-align: center;
  color: #393939;
  font-weight: bold;
  margin-bottom: 20px;
`;

const Description = styled.div`
  font-size: 18px;
  text-align: center;
  margin: 0 5% 0 5%;
`;

const LoginButton = styled(Button)`
  background-color: white;
  // color: ${(props) => props.theme.primary.contrast};
  color: #4285F4;
  margin: 0 auto;
  padding: 0 50px;
  border: 2px solid #4285F4;
`;

const RegistredButton = styled(Button)`
  background-color: ${(props) => props.theme.primary.background};
  color: ${black};
  margin: 0 auto;
  padding: 0 50px;
`;

const Logo = styled.img`
  height: auto;
  width: 8%;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 15%;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100px;
`;

export default DisplayHasAccount;
